import React, { useState } from "react"

import { Input, Select, Button, InfoBox } from "../../../../design-system"
import ImportCNPJ from "../../../../_components/ImportCNPJ"

const Company = props => {
    const data = props.data || {};
    const errors = props.errors || {};

    const handleChange = (e) => {
        if (props.onChange) {
            props.onChange({ [e.target.name]: e.target.value });
        }
    };

    return <div className={props.show ? "row mt-4" : "d-none"}>
        <div className="col-md-4 mb-4">
            <ImportCNPJ 
                label="CNPJ"
                name="cnpj"
                cnpj={data.cnpj}
                value={data.cnpj}
                onChange={handleChange}
                type="branch"
                onSuccess={(cnpjData) => {
                    const newData = {};
                    if (cnpjData.name) newData.razaoSocial = cnpjData.name;
                    if (cnpjData.email) newData.email = cnpjData.email;
                    if (cnpjData.phone) newData.phone_number = cnpjData.phone;
                    if (cnpjData.company && cnpjData.company.fancy_name) newData.nomeFantasia = cnpjData.company.fancy_name;
                    if (cnpjData.company && cnpjData.company.main_cnae) {
                        newData.cnae = cnpjData.company.main_cnae;
                        newData.cnae_code = cnpjData.company.main_cnae_code;
                    }
                    if (Object.keys(newData).length > 0 && props.onChange) {
                        props.onChange(newData);
                    }
                    if (cnpjData.address && props.onAddressImport) {
                        props.onAddressImport({
                            postal_code: cnpjData.address.postal_code || "",
                            street: cnpjData.address.street || "",
                            street_number: cnpjData.address.street_number || "",
                            complement: cnpjData.address.complement || "",
                            district: cnpjData.address.district || "",
                            state_id: cnpjData.address.state_location || null,
                            city_id: cnpjData.address.city_location || null,
                            state_uf: cnpjData.address.state_location_uf || "",
                            city: cnpjData.address.city_location_name || "",
                        });
                    }
                }}
            />
        </div>
        
        <div className="col-md-4 mb-4">
            <Input 
                label="Razão Social" 
                name="razaoSocial"
                value={data.razaoSocial || ""} 
                onChange={handleChange} 
            />
        </div>

        <div className="col-md-4 mb-4">
            <Input 
                label="Email da empresa" 
                name="email"
                type="email"
                value={data.email || ""} 
                onChange={handleChange} 
                error={errors.email}
            />
        </div>

        <div className="col-md-4 mb-4">
            <Input 
                label="Telefone da empresa" 
                name="phone_number"
                type="telefone"
                value={data.phone_number || ""} 
                onChange={handleChange} 
                error={errors.phone_number}
            />
        </div>
        
        <div className="col-md-4 mb-4">
            <Input 
                label="Nome Fantasia" 
                name="nomeFantasia"
                value={data.nomeFantasia || ""} 
                onChange={handleChange} 
            />
        </div>
        
        <div className="col-md-4 mb-4">
            <Select 
                label="CRT" 
                name="crt"
                options={[
                    { value: "", label: "Selecione" },
                    { value: "1", label: "1 - Simples Nacional" },
                    { value: "2", label: "2 - Simples Nacional - excesso de sublimite da receita bruta" },
                    { value: "3", label: "3 - Regime Normal" },
                    { value: "4", label: "4 - Simples Nacional - MEI" }
                ]}
                value={data.crt || ""}
                onChange={handleChange}
                error={errors.crt}
            />
        </div>
        
        <div className="col-md-4 mb-4">
            <Input 
                label="Inscrição Estadual" 
                name="inscricaoEstadual"
                value={data.inscricaoEstadual || ""} 
                onChange={handleChange} 
            />
            <InfoBox
                onClick={() => window.open("http://", "_blank")}
                icon="fa fa-info-circle"
            >
                <span style={{ fontSize: "13px", fontWeight: 500, color: "#00A9FF" }}>Não sei minha Inscrição Estadual</span>
            </InfoBox>
            <div className="mt-1">
                <span
                    style={{ fontSize: "12px", color: "#00A9FF", cursor: "pointer" }}
                    onClick={() => {
                        if (props.onChange) {
                            props.onChange({ inscricaoEstadual: "ISENTO" });
                        }
                    }}
                >
                    Preencher como ISENTO
                </span>
            </div>
        </div>
        
        <div className="col-md-4 mb-4">
            <Input 
                label="Inscrição Municipal" 
                name="inscricaoMunicipal"
                value={data.inscricaoMunicipal || ""} 
                onChange={handleChange} 
            />
            <InfoBox
                onClick={() => window.open("http://", "_blank")}
                icon="fa fa-info-circle"
            >
                <span style={{ fontSize: "13px", fontWeight: 500, color: "#00A9FF" }}>Não sei minha Inscrição Municipal</span>
            </InfoBox>
        </div>
        
        <div className="col-md-4 mb-4">
            <div className="d-flex align-items-end gap-2">
                <div className="flex-grow-1">
                    <Input 
                        label="Atividade principal (CNAE)" 
                        name="cnae_code"
                        value={data.cnae_code || ""} 
                        onChange={handleChange} 
                    />
                </div>
                <Button variant="secondary" shape="rectangle" style={{ height: "42px", padding: "0 16px" }}>
                    <i className="fas fa-search"></i>
                </Button>
            </div>
            <InfoBox
                onClick={() => window.open("http://", "_blank")}
                icon="fa fa-info-circle"
            >
                <span style={{ fontSize: "13px", fontWeight: 500, color: "#00A9FF" }}>Não sei meu CNAE</span>
            </InfoBox>
        </div>
    </div>
}

export default Company


// WEBPACK FOOTER //
// ./src/views/AppViews/Branches/Company/index.jsx